import raw from '../RELEASE-NOTES.md?raw';
import { loadReleaseNotes } from './helpers/release-notes.loader';

/** The released entries of frontend/RELEASE-NOTES.md, newest first, and the app version (the first one). */
export const { entries: RELEASE_NOTES, version: APP_VERSION } = loadReleaseNotes(raw);
